import { Component, DestroyRef, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { SolPreferencesService } from '../../../../../services/preferences/sol-preferences.service';
import { DropDownItem } from '../../../../../models/dtos';
import { ISolPreferencesContactInfoFormGroup } from '../../../../../models/preferences/ISolPreferencesContactInfoFormGroup';
import { CommonMetaDataService } from '../../../../../services/common-meta-data.service';
import { StaticDropdownService } from '../../../../../services/common/static-dropdown.service';

@Component({
  selector: 'app-sol-preferences-contact-info',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    TranslatePipe
  ],
  templateUrl: './sol-preferences-contact-info.component.html',
  styleUrls: ['./sol-preferences-contact-info.component.scss']
})
export class SolPreferencesContactInfoComponent implements OnInit {
  contactInfoForm!: FormGroup<ISolPreferencesContactInfoFormGroup>;
  companyNames: DropDownItem[] = [];
  countries: DropDownItem[] = [];

  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly preferencesService: SolPreferencesService,
    private readonly destroyRef: DestroyRef,
    private readonly commonMetaDataService: CommonMetaDataService,
    private readonly staticDropdownService: StaticDropdownService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  private initializeForm(): void {
    this.staticDropdownService.getCountries()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((countries) => {
        this.countries = countries;
      });
    const userPreferences = this.preferencesService.getUserPreferences();
    this.companyNames = this.commonMetaDataService.getMetaData()?.companies ?? [];
    this.contactInfoForm = this.fb.group<ISolPreferencesContactInfoFormGroup>({
      companyName: this.fb.control<string>(userPreferences.preferences.companyName),
      country: this.fb.control<number>(userPreferences.preferences.projectCountry),
      officeAddress1: this.fb.control<string>(userPreferences.preferences.branchAddress1),
      officeAddress2: this.fb.control<string>(userPreferences.preferences.branchAddress2),
      officeState: this.fb.control<string>(userPreferences.preferences.branchState),
      officeZipCode: this.fb.control<string>(userPreferences.preferences.branchZipCode),
      officeContact: this.fb.control<string>(userPreferences.preferences.branchContact),
      officeEmail: this.fb.control<string>(userPreferences.preferences.branchEmail),
      websiteAddress: this.fb.control<string>(userPreferences.preferences.websiteAddress)
    });

    // Sync every form change back to the shared service
    this.contactInfoForm.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        this.preferencesService.silentSetPreferences(data => {
          data.preferences.companyName = value.companyName ?? '';
          data.preferences.projectCountry = value.country ?? 0;
          data.preferences.branchAddress1 = value.officeAddress1 ?? '';
          data.preferences.branchAddress2 = value.officeAddress2 ?? '';
          data.preferences.branchState = value.officeState ?? '';
          data.preferences.branchZipCode = value.officeZipCode ?? '';
          data.preferences.branchContact = value.officeContact ?? '';
          data.preferences.branchEmail = value.officeEmail ?? '';
          data.preferences.websiteAddress = value.websiteAddress ?? '';
        });
      });
  }
}
